export const ActivitySpeciesTypeConstants = {
    NOT_ON_LIST: '9c9c1a74-f6ae-4b31-9865-06005c1c4ead'
};
